var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visitor-unavailable"},[_c('div',{staticClass:"card"},[_c('van-empty',{attrs:{"description":_vm.descriptionText}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }